// @flow

import Resource from 'speed-js-core/src/api/Resource';
import type { ID, UUID } from 'esm-web-pro/types/common';
import PRESENCES from 'esm-web-pro/containers/panels/calling/presence/presences';

export default class PhoneResource extends Resource {
    basePath: string = 'communication/phone';

    outboundCall(contactDetailUuid: UUID, taskUuid: UUID, userContactDetailUuid: ?UUID, phoneNumber: ?string) {
        const data = {
            contact_detail_uuid: contactDetailUuid,
            task_uuid: taskUuid,
        };

        if (userContactDetailUuid) {
            data.user_contact_detail_uuid = userContactDetailUuid;
        }

        if (phoneNumber) {
            data.phone_number = phoneNumber;
        }

        return this.client._request(`${this._getBasePath()}/click_to_call`, 'GET', data);
    }

    inboundCall(sipId: ID, phoneNumber: string) {
        return this.client._request(`${this._getBasePath()}/inbound_call`, 'GET', {
            sip_id: sipId,
            phone_number: phoneNumber,
        });
    }

    credentials() {
        return this.client._request(`${this._getBasePath()}/credentials`, 'GET');
    }

    phoneCountryCode(countryCode: string) {
        return this.client._request(`${this._getBasePath()}/phone_country_code`, 'GET', {
            country_code: countryCode,
        });
    }

    parse(phoneNumber: string) {
        return this.client._request(`${this._getBasePath()}/parse_phone`, 'POST', {
            number: phoneNumber,
        });
    }

    /**
     *
     * @return {Promise<{ok: boolean, status: number, statusText: string, headers: Object, data: Object}>}
     * Return promise that can be used to get call centers data
     */
    callCenters() {
        return this.client._request(`${this._getBasePath()}/call_centers`, 'GET');
    }

    setAgentStatus(agentUuid: UUID, status: $Keys<typeof PRESENCES>) {
        return this.client._request(`${this._getBasePath()}/agent_status`, 'POST', {
            agent_uuid: agentUuid,
            status,
        });
    }
}
